module.exports = __webpack_public_path__ + "static/media/bar-hit.f7475a59.svg";